import { api } from '../../context/AuthContext';
import { API } from '../../config/api';
import { toast } from 'sonner';

/**
 * Reusable home-feature star button.
 *
 * <HomeFeatureStar item={beat} endpoint="beats" onToggled={(featured, count) => ...} />
 *
 * endpoint values:
 *   tracks, beats, merch, albums, mixtapes, free-media, videos, featured-artists
 *
 * The button calls `PUT /api/{endpoint}/home-featured/{item.id}` (which toggles)
 * and surfaces a toast on success/error.
 */
export function HomeFeatureStar({ item, endpoint, onToggled, className = '' }) {
  const id = item?.id;
  if (!id) return null;
  const handle = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    try {
      const { data } = await api.put(`${API}/${endpoint}/home-featured/${id}`);
      toast.success(data.featured ? `★ Featured on homepage (${data.count}/6)` : '☆ Removed from homepage');
      if (onToggled) onToggled(data.featured, data.count);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Toggle failed');
    }
  };
  const starred = !!item.home_featured;
  return (
    <button
      onClick={handle}
      title={starred
        ? `Featured on homepage (#${(item.home_featured_order ?? 0) + 1}/6) — click to remove`
        : 'Show on homepage (max 6)'}
      className={`shrink-0 text-base leading-none transition-colors ${
        starred ? 'text-[#DAA520] hover:text-[#FFD700]' : 'text-[#404040] hover:text-[#DAA520]'
      } ${className}`}
      data-testid={`home-feature-${endpoint}-${id}`}
    >
      {starred ? '★' : '☆'}
    </button>
  );
}
